import React from 'react';
import { HeroSection } from '../components/home/HeroSection';
import { StatsSection } from '../components/home/StatsSection';
import { HowItWorks } from '../components/home/HowItWorks';
import { Categories } from '../components/home/Categories';
import { FeaturedTutors } from '../components/home/FeaturedTutors';
import { SubjectCategories } from '../components/home/SubjectCategories';
import { Testimonials } from '../components/home/Testimonials';
import { AboutSection } from '../components/home/AboutSection';
import { ContactSection } from '../components/home/ContactSection';

export const Home = () => {
  return (
    <div className="min-h-screen">
      <HeroSection />
      <StatsSection />
      <Categories />
      <HowItWorks />
      <SubjectCategories />
      <FeaturedTutors />
      <Testimonials />
      <AboutSection />
      <ContactSection />
    </div>
  );
};
